import api from '../../plugins/api';

const getClientDocumentTypes = (params) => {
  return api.get('/api/crm/clients/getClientDocumentTypes', params);
};

export default getClientDocumentTypes;
